import type { enHost } from '../en/host.js';

export const deHost: Record<keyof typeof enHost, string> = {
  "h.title": "Empfang",
  "h.nearby": "In der Nähe: {times}",
  "h.pc.title": "Passcode des Restaurants",
  "h.pc.body": "Diese Aktion ist geschützt. Geben Sie zum Fortfahren den Passcode des Restaurants ein.",
  "h.pc.aria": "Passcode",
  "h.pc.wrong": "Falscher Passcode. Bitte erneut versuchen.",
  "h.continue": "Weiter",
  "h.login.doc": "Anmelden · Empfang",
  "h.login.sub": "Melden Sie sich mit Ihrem Mitarbeiterkonto an.",
  "h.login.twostep": "Zwei-Faktor-Anmeldung",
  "h.login.code_label": "Authentifizierungscode",
  "h.login.code_hint": "Geben Sie den 6-stelligen Code aus Ihrer Authenticator-App oder einen Wiederherstellungscode ein.",
  "h.login.verify": "Bestätigen",
  "h.login.other_account": "Anderes Konto verwenden",
  "h.login.one_more": "Noch ein Schritt.",
  "h.login.email": "E-Mail",
  "h.login.reset_link": "Link zum Zurücksetzen per E-Mail senden",
  "h.login.back": "Zurück zur Anmeldung",
  "h.login.reset_title": "Passwort zurücksetzen",
  "h.login.reset_sub": "Wir senden einen Link, wenn die Adresse zu einem Konto gehört.",
  "h.login.new_pass": "Neues Passwort (mindestens 10 Zeichen)",
  "h.login.set_pass": "Passwort festlegen",
  "h.login.choose_title": "Neues Passwort wählen",
  "h.login.once": "Dieser Link funktioniert nur einmal.",
  "h.login.sso": "Mit Single Sign-on anmelden",
  "h.login.sso_enforced": "Ihr Restaurant verlangt Single Sign-on. Nur der Inhaber kann ein Passwort verwenden.",
  "h.login.or_password": "Oder verwenden Sie Ihr Passwort:",
  "h.login.password": "Passwort",
  "h.login.submit": "Anmelden",
  "h.login.forgot": "Passwort vergessen?",
  "h.login.session_ended": "Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.",
  "h.login.mfa_title": "Zwei-Faktor-Anmeldung einrichten",
  "h.login.mfa_body": "Ihr Restaurant verlangt sie, bevor Sie fortfahren können.",
  "h.login.reset_sent": "Wenn die Adresse zu einem Konto gehört, ist ein Link zum Zurücksetzen unterwegs.",
  "h.login.pass_changed": "Passwort geändert. Sie können sich jetzt anmelden.",
  "h.login.bad_code": "Dieser Code ist nicht korrekt.",
  "h.login.bad_creds": "E-Mail, Passwort oder Code ist nicht korrekt.",
  "h.date_aria": "Datum",
  "h.prev_day": "Vorheriger Tag",
  "h.today": "Heute",
  "h.next_day": "Nächster Tag",
  "h.shift_aria": "Schicht",
  "h.closed": "Geschlossen",
  "h.covers": "{n} Gedecke",
  "h.view_aria": "Ansicht",
  "h.view.floor": "Saalplan",
  "h.view.list": "Liste",
  "h.view.timeline": "Zeitleiste",
  "h.view.overview": "Übersicht",
  "h.view.calendar": "Kalender",
  "h.book": "+ Reservieren",
  "h.waitlist_add": "+ Warteliste",
  "h.statuses": "Status",
  "h.statuses_title": "Statusverwaltung",
  "h.config": "Konfiguration",
  "h.config_title": "Schichten, Tische, Richtlinien (Entwurf und Veröffentlichung)",
  "h.team": "Team",
  "h.team_title": "Mitarbeiter, Rollen und Passcode",
  "h.security": "Sicherheit",
  "h.security_title": "Zwei-Faktor-Anmeldung und Passwort",
  "h.sign_out": "Abmelden",
  "h.table_n": "Tisch {label}",
  "h.unassigned": "Nicht zugewiesen",
  "h.not_assigned": "Nicht zugewiesen",
  "h.wait.progress": "{waited} von {quoted} Min.",
  "h.wait.notified": "benachrichtigt",
  "h.group.waitlist": "Warteliste",
  "h.group.reservations": "Reservierungen",
  "h.group.seated": "Platziert",
  "h.group.finished": "Beendet",
  "h.group.removed": "Entfernt",
  "h.parties_aria": "Gruppen",
  "h.none": "Keine",
  "h.tbl.blocked": "gesperrt",
  "h.tbl.held": "gehalten",
  "h.tbl.aria": "Tisch {label}, {state}",
  "h.tbl.free": "frei",
  "h.party_fallback": "Gruppe",
  "h.banner.seat": "{name} platzieren: Tisch wählen",
  "h.banner.assign": "{name} vorab zuweisen: Tisch wählen",
  "h.banner.move": "{name} umsetzen: neuen Tisch wählen",
  "h.banner.waitseat": "Wartelisten-Gruppe platzieren: Tisch wählen",
  "h.banner.walkin": "Laufkundschaft ({n}) platzieren: Tisch wählen",
  "h.tl.no_shift": "An diesem Tag gibt es keine Schicht.",
  "h.tl.blocked": "Gesperrt",
  "h.tl.booked": "Gebucht",
  "h.tl.table": "Tisch",
  "h.tl.covers": "Gedecke",
  "h.tl.cap": "/Limit",
  "h.tl.cell_title": "{c} Gedecke von {m}, {p} Gruppen",
  "h.tl.cell_title_free": "{c} Gedecke, {p} Gruppen",
  "h.ov.no_data": "Keine Daten.",
  "h.ov.shift": "Schicht",
  "h.ov.covers": "Gedecke",
  "h.ov.booked": "Reserviert",
  "h.ov.seated": "Platziert",
  "h.ov.waitlist": "Warteliste",
  "h.ov.by_time": "Gedecke nach Uhrzeit",
  "h.ov.by_source": "Gedecke nach Quelle",
  "h.ov.by_size": "Gruppen nach Größe",
  "h.ov.servers": "Service-Bereiche",
  "h.source.website": "Webseite",
  "h.source.network": "Netzwerk",
  "h.source.phone": "Telefon",
  "h.source.host": "Empfang",
  "h.source.walk_in": "Laufkundschaft",
  "h.d.aria": "Gruppendetails",
  "h.d.status": "Status",
  "h.d.table": "Tisch",
  "h.d.duration": "Dauer",
  "h.d.elapsed": "{time} vergangen",
  "h.d.phone": "Telefon",
  "h.d.occasion": "Anlass",
  "h.d.request": "Wunsch",
  "h.d.policy": "Richtlinie",
  "h.d.payment": "Zahlung",
  "h.d.code": "Nummer",
  "h.policy.card_hold": "Kartengarantie",
  "h.policy.deposit": "Anzahlung",
  "h.a.seat_now": "Jetzt platzieren",
  "h.a.seat": "Platzieren…",
  "h.a.preassign": "Vorab zuweisen",
  "h.a.move": "Tisch wechseln",
  "h.a.finish": "Beenden",
  "h.a.edit": "Bearbeiten",
  "h.a.noshow": "Nicht erschienen",
  "h.a.cancel": "Stornieren",
  "h.d.exclude": "Vom Pacing-Limit ausnehmen",
  "h.d.excluded": "Vom Pacing-Limit ausgenommen",
  "h.d.emails": "E-Mails an den Gast",
  "h.d.resend": "Bestätigung erneut senden",
  "h.d.notes": "Notizen",
  "h.d.no_notes": "Keine Notizen",
  "h.pay.pending": "Wartet auf Karte",
  "h.pay.card_saved": "Karte hinterlegt",
  "h.pay.deposit_paid": "Anzahlung bezahlt: {amount}",
  "h.pay.fee_collected": "Gebühr eingezogen",
  "h.pay.forfeited": "Anzahlung einbehalten: {amount}",
  "h.pay.released": "Karte freigegeben",
  "h.pay.refunded": "Anzahlung erstattet",
  "h.pay.failed": "Zahlung fehlgeschlagen",
  "h.pay.canceled": "Zahlung abgebrochen",
  "h.pay.fee_due": "Gebühr fällig: {amount}",
  "h.pay.charge": "Gebühr einziehen",
  "h.pay.refund_pending": "Erstattung ausstehend: {amount}",
  "h.pay.refund": "Erstatten",
  "h.w.aria": "Wartelisten-Gruppe",
  "h.w.quoted": "Zugesagt",
  "h.w.waiting": "Wartet seit",
  "h.w.minutes": "{n} Min.",
  "h.w.status.waiting": "wartet",
  "h.w.status.notified": "benachrichtigt",
  "h.w.status.seated": "platziert",
  "h.w.status.removed": "entfernt",
  "h.w.notify": "Benachrichtigen (Tisch bereit)",
  "h.w.seat": "Platzieren…",
  "h.w.remove": "Entfernen",
  "h.w.no_permission": "Ihre Rolle darf die Warteliste nicht verwalten.",
  "h.t.aria": "Tischdetails",
  "h.t.seats": "{min}–{max} Plätze",
  "h.t.party": "Gruppe",
  "h.t.elapsed": "Vergangen",
  "h.t.open_party": "Gruppe öffnen",
  "h.t.blocked": "Gesperrt",
  "h.t.held": "Für einen Gast im Buchungsvorgang gehalten",
  "h.t.free": "Frei",
  "h.t.next": "nächste Reservierung {time}",
  "h.t.walkin": "Laufkundschaft platzieren",
  "h.t.block": "1 Stunde sperren",
  "h.t.no_bookings": "Keine Reservierungen",
  "h.render_failed": "Die Ansicht konnte nicht angezeigt werden: {error}",
  "h.em.confirmation": "Bestätigung",
  "h.em.reminder": "Erinnerung",
  "h.em.change": "Änderungsmitteilung",
  "h.em.cancellation": "Stornierung",
  "h.em.sent": "gesendet {time}",
  "h.em.failed": "fehlgeschlagen: {error}",
  "h.em.skipped": "nicht nötig",
  "h.em.queued": "geplant für {time}",
  "h.em.none": "Noch keine E-Mails. Möglicherweise ist keine E-Mail-Adresse hinterlegt.",
  "h.note.general": "Allgemein",
  "h.note.relationship": "Beziehung",
  "h.note.food_drink": "Essen & Trinken",
  "h.note.seating": "Sitzplatz",
  "h.note.visit": "Besuch",
  "h.book.title": "Tisch reservieren",
  "h.book.date": "Datum",
  "h.book.time": "Uhrzeit",
  "h.book.party": "Personen",
  "h.book.find": "Zeiten suchen",
  "h.book.override": "Pacing-Limit übergehen",
  "h.book.override_pass": "Passcode für das Übergehen",
  "h.book.first": "Vorname",
  "h.book.last": "Nachname",
  "h.book.phone": "Telefon",
  "h.book.email": "E-Mail",
  "h.book.request": "Besondere Wünsche",
  "h.book.language": "Sprache des Gastes",
  "h.book.submit": "Reservieren",
  "h.book.searching": "Suche läuft…",
  "h.book.none": "Keine Verfügbarkeit",
  "h.book.done": "{name} gebucht · Nummer {code}",
  "h.wl.title": "Zur Warteliste hinzufügen",
  "h.wl.name": "Name",
  "h.wl.name_ph": "Name oder Beschreibung",
  "h.wl.party": "Personenzahl",
  "h.wl.quote": "Zugesagte Wartezeit (Min., leer = Schätzung)",
  "h.wl.phone": "Telefon",
  "h.wl.sms": "SMS, wenn der Tisch bereit ist",
  "h.wl.submit": "Zur Warteliste hinzufügen",
  "h.wl.quoted": "{n} Min. zugesagt",
  "h.wl.quoted_free": "{n} Min. zugesagt. Ein Tisch ist gerade frei, Sie können die Gruppe direkt platzieren.",
  "h.edit.title": "{name} bearbeiten",
  "h.edit.duration": "Dauer (Minuten)",
  "h.edit.override": "Pacing-Limit beim Verschieben übergehen",
  "h.edit.saved": "Gespeichert",
  "h.st.title": "Statusverwaltung",
  "h.st.hint": "Wählen Sie, welche Status das Personal verwenden kann. Gesperrte Status sind immer aktiv.",
  "h.st.locked": "(fest)",
  "h.team.title": "Team",
  "h.team.staff": "Mitarbeiter",
  "h.team.role_for": "Rolle für {name}",
  "h.team.active": "Aktiv",
  "h.team.reset_pw": "Passwort zurücksetzen",
  "h.team.reset_mfa": "Zwei-Faktor zurücksetzen",
  "h.team.mfa_on": "Die Zwei-Faktor-Anmeldung ist aktiv",
  "h.team.builtin": "integriert",
  "h.team.custom": "eigene",
  "h.team.members_one": "{n} Mitglied",
  "h.team.members_other": "{n} Mitglieder",
  "h.team.no_perms": "Keine Berechtigungen",
  "h.team.policy": "Anmelderichtlinie",
  "h.team.require_mfa": "Zwei-Faktor-Anmeldung für alle verlangen, die ein Passwort verwenden",
  "h.team.sso": "Single Sign-on (OpenID Connect)",
  "h.team.sso_hint": "Tragen Sie diese Weiterleitungs-URI bei Ihrem Identitätsanbieter ein: {uri}. Personen müssen hier bereits ein Konto haben; vom Anbieter wird nichts angelegt.",
  "h.team.issuer": "Aussteller-URL",
  "h.team.client_id": "Client-ID",
  "h.team.client_secret": "Client-Geheimnis",
  "h.team.keep_blank": "(leer lassen, um es zu behalten)",
  "h.team.domains": "Erlaubte E-Mail-Domains (durch Komma getrennt)",
  "h.team.enabled": "Aktiviert",
  "h.team.enforce": "Für alle außer dem Inhaber verlangen",
  "h.team.sso_save": "Single Sign-on speichern",
  "h.team.add_person": "Person hinzufügen",
  "h.team.name": "Name",
  "h.team.email": "E-Mail",
  "h.team.role": "Rolle",
  "h.team.initial_pw": "Anfangspasswort (mindestens 10 Zeichen)",
  "h.team.add_btn": "Person hinzufügen",
  "h.team.roles": "Rollen",
  "h.team.new_role": "Neue eigene Rolle",
  "h.team.role_name": "Rollenname",
  "h.team.create_role": "Rolle erstellen",
  "h.team.passcode": "Passcode für geschützte Aktionen",
  "h.team.pass_set": "Ein Passcode ist gesetzt.",
  "h.team.pass_unset": "Es ist kein Passcode gesetzt.",
  "h.team.pass_hint": "Das Sperren von Tischen und das Übergehen des Pacing-Limits fragen danach, außer die Rolle überspringt die Abfrage.",
  "h.team.pass_ph": "4 bis 8 Ziffern",
  "h.team.pass_new": "Neuer Passcode",
  "h.team.set_pass": "Passcode setzen",
  "h.team.saved": "Gespeichert",
  "h.team.pw_prompt": "Neues Passwort für diese Person (mindestens 10 Zeichen). Sie wird überall abgemeldet.",
  "h.team.pw_reset_done": "Passwort zurückgesetzt; die Sitzungen wurden beendet.",
  "h.team.mfa_reset_confirm": "Zwei-Faktor-Anmeldung für diese Person löschen? Sie wird abgemeldet und kann sie neu einrichten.",
  "h.team.sso_saved": "Single Sign-on gespeichert.",
  "h.team.sso_remove_confirm": "Single Sign-on entfernen? Die Anmeldung per Passwort gilt dann wieder für alle.",
  "h.sec.title": "Kontosicherheit",
  "h.sec.twostep": "Zwei-Faktor-Anmeldung",
  "h.sec.save_codes": "Speichern Sie diese Wiederherstellungscodes jetzt.",
  "h.sec.codes_hint": "Jeder funktioniert einmal, falls Sie Ihr Telefon verlieren. Sie werden nicht erneut angezeigt.",
  "h.sec.copy": "Kopieren",
  "h.sec.saved_them": "Ich habe sie gespeichert",
  "h.sec.step1": "Wählen Sie in Ihrer Authenticator-App „Setup-Schlüssel eingeben“.",
  "h.sec.step2": "Konto: {email}, Schlüssel:",
  "h.sec.key_aria": "Setup-Schlüssel",
  "h.sec.key_type": "Typ: zeitbasiert, 6 Stellen, 30 Sekunden.",
  "h.sec.enter_code": "Geben Sie dann den 6-stelligen Code ein, den die App anzeigt",
  "h.sec.turn_on": "Aktivieren",
  "h.sec.is_on": "Die Zwei-Faktor-Anmeldung ist aktiv.",
  "h.sec.codes_left_one": "Noch {n} Wiederherstellungscode.",
  "h.sec.codes_left_other": "Noch {n} Wiederherstellungscodes.",
  "h.sec.password": "Passwort",
  "h.sec.current_code": "Aktueller Code",
  "h.sec.new_codes": "Neue Wiederherstellungscodes",
  "h.sec.turn_off": "Deaktivieren",
  "h.sec.required": "Ihr Restaurant verlangt die Zwei-Faktor-Anmeldung.",
  "h.sec.add_step": "Fügen Sie einen zweiten Schritt hinzu, um Ihr Konto zu schützen.",
  "h.sec.setup": "Einrichten",
  "h.sec.copied": "Kopiert.",
  "h.sec.is_off": "Die Zwei-Faktor-Anmeldung ist deaktiviert.",
  "h.sec.pw_heading": "Passwort",
  "h.sec.change_pw": "Passwort ändern",
  "h.pw.title": "Passwort ändern",
  "h.pw.current": "Aktuelles Passwort",
  "h.pw.new": "Neues Passwort (mindestens 10 Zeichen)",
  "h.pw.hint": "Sie bleiben hier angemeldet; andere Geräte werden abgemeldet.",
  "h.pw.changed": "Passwort geändert",
  "h.walkin.title": "Laufkundschaft an Tisch {label} platzieren",
  "h.walkin.party": "Personenzahl",
  "h.walkin.name": "Name (optional)",
  "h.walkin.submit": "Platzieren",
  "role.Owner": "Inhaber",
  "role.Manager": "Leitung",
  "role.Front of house": "Service",
  "role.Viewer": "Nur Lesen",
  "perm.host.view": "Empfang, Saalplan und Reservierungslisten ansehen",
  "perm.reservations.manage": "Reservierungen anlegen, ändern und stornieren",
  "perm.host.seat": "Gruppen platzieren, Status ändern, Tische wechseln, Notizen hinzufügen",
  "perm.waitlist.manage": "Wartelistengruppen hinzufügen, benachrichtigen, platzieren und entfernen",
  "perm.tables.block": "Tische sperren (geschützt: Passcode des Restaurants nötig)",
  "perm.pacing.override": "Über Pacing-Limits hinaus buchen (geschützt: Passcode nötig)",
  "perm.settings.manage": "Buchungseinstellungen und Statusverwaltung ändern",
  "perm.staff.manage": "Mitarbeiter, Rollen und Passcode des Restaurants verwalten",
  "perm.protected.bypass": "Passcode-Abfragen für geschützte Aktionen überspringen",
  "perm.config.edit": "Entwurf der Konfiguration bearbeiten (Schichten, Tische, Richtlinien)",
  "perm.config.publish": "Konfiguration veröffentlichen oder wiederherstellen",
  "perm.payments.manage": "Gebühren bei Nichterscheinen und später Stornierung einziehen, Anzahlungen erstatten",
  "perm.billing.view": "Rechnungen für das Abonnement dieses Restaurants ansehen und herunterladen",
  "h.n.type": "Notiztyp",
  "h.n.general": "Allgemein",
  "h.n.relationship": "Beziehung",
  "h.n.food_drink": "Essen & Trinken",
  "h.n.seating": "Sitzplatz",
  "h.n.visit": "Besuch",
  "h.n.placeholder": "Notiz hinzufügen",
  "h.n.text": "Notiztext",
  "h.n.add": "Notiz speichern",
  "h.toast.walkin": "Laufkundschaft platziert",
  "h.toast.preassigned": "Vorab zugewiesen",
  "h.toast.seated": "Platziert",
  "h.toast.moved": "Umgesetzt",
  "h.toast.seated_wait": "Von der Warteliste platziert",
  "h.toast.load_day_failed": "{date} konnte nicht geladen werden: {error}",
  "h.toast.load_shift_failed": "Die Schicht konnte nicht geladen werden: {error}",
  "h.toast.freed": "Tisch freigegeben",
  "h.confirm.cancel": "Diese Reservierung stornieren?",
  "h.toast.cancelled": "Storniert",
  "h.confirm.noshow": "Als nicht erschienen markieren?",
  "h.toast.noshow": "Als nicht erschienen markiert",
  "h.toast.blocked": "Für 1 Stunde gesperrt",
  "h.toast.queued": "Bestätigung wird gesendet",
  "h.confirm.charge": "Hinterlegte Karte mit {amount} belasten?",
  "h.toast.charged": "{amount} abgebucht",
  "h.toast.charge_pending": "Der Zahlungsanbieter ist nicht erreichbar. Versuchen Sie es gleich erneut; die Karte wird nie doppelt belastet.",
  "h.toast.declined": "Karte abgelehnt: {reason}",
  "h.confirm.refund": "{amount} auf die Karte des Gastes erstatten?",
  "h.toast.refunded": "{amount} erstattet",
  "h.toast.refund_pending": "Die Erstattung konnte noch nicht abgeschlossen werden; sie wird erneut versucht.",
  "h.toast.notified_sms": "Als benachrichtigt markiert. Der SMS-Versand ist noch nicht angebunden, bitte informieren Sie {to} selbst.",
  "h.toast.notified": "Als benachrichtigt markiert (keine SMS-Einwilligung, bitte informieren Sie den Gast selbst).",
  "h.toast.removed": "Entfernt",
  "h.toast.status": "Status aktualisiert",
  "h.toast.updated": "Aktualisiert",
  "h.toast.timeline_hint": "Tisch {label} um {time}: Nutzen Sie „+ Reservieren“ für diese Zeit",
  "c.title": "Konfiguration",
  "c.nav_aria": "Bereiche der Konfiguration",
  "c.sec.shifts": "Schichten",
  "c.sec.tables": "Tische",
  "c.sec.layout": "Raumplan",
  "c.sec.policies": "Richtlinien",
  "c.sec.closures": "Schließtage",
  "c.sec.settings": "Einstellungen",
  "c.sec.branding": "Marke & E-Mails",
  "c.sec.history": "Verlauf",
  "c.loading": "Wird geladen…",
  "c.live_initial": "Aktiv (Ausgangszustand)",
  "c.live_v": "Aktiv v{v}",
  "c.changes_one": "{n} unveröffentlichte Änderung",
  "c.changes_other": "{n} unveröffentlichte Änderungen",
  "c.saving": " · wird gespeichert…",
  "c.no_draft": "Kein Entwurf: Sie sehen die aktive Konfiguration",
  "c.discard": "Entwurf verwerfen",
  "c.publish": "Veröffentlichen",
  "c.publishing": "Wird veröffentlicht…",
  "c.publish_needs_perm": "Sie benötigen die Berechtigung zum Veröffentlichen",
  "c.start_intro": "Sie sehen die aktive Konfiguration. Änderungen werden in einem Entwurf vorgenommen und gehen erst mit der Veröffentlichung live.",
  "c.start": "Bearbeitung beginnen",
  "c.live_now": "Derzeit aktiv",
  "c.live_shifts": "{n} Schichten: {list}",
  "c.live_tables": "{t} Tische, {c} Kombinationen",
  "c.live_policies": "{n} Richtlinien: {list}",
  "c.live_closures": "{n} Schließtage oder Sondertage",
  "c.discard_confirm": "Alle unveröffentlichten Änderungen verwerfen?",
  "c.published": "Version {v} veröffentlicht",
  "c.restore_confirm": "Den aktuellen Entwurf durch Version {v} ersetzen?",
  "c.review": "Prüfung",
  "c.stale": "Die aktive Konfiguration hat sich geändert, nachdem dieser Entwurf begonnen wurde. Stellen Sie die neueste Version als neuen Entwurf wieder her, um fortzufahren.",
  "c.no_changes": "Noch keine Änderungen.",
  "c.fix_first": "Vor dem Veröffentlichen beheben",
  "c.check": "Bitte prüfen",
  "c.note": "Notiz für den Verlauf",
  "c.note_ph": "Was wurde geändert und warum",
  "c.d.settings": "Einstellungen",
  "c.d.changed_fields": "geändert: {list}",
  "c.d.areas": "Bereiche",
  "c.d.floorPlans": "Raumpläne",
  "c.d.tables": "Tische",
  "c.d.features": "Wände und Einbauten",
  "c.d.combos": "Kombinationen",
  "c.d.specialDays": "Schließtage",
  "c.d.shifts": "Schichten",
  "c.d.policies": "Richtlinien",
  "c.d.branding": "Marke",
  "c.d.emailTemplates": "E-Mail-Texte",
  "c.d.added": "hinzugefügt",
  "c.d.changed": "geändert",
  "c.d.removed": "entfernt",
  "c.s.name": "Name",
  "c.s.colour": "Farbe",
  "c.s.first": "Erste Platzierung",
  "c.s.last": "Letzte Platzierung",
  "c.s.max_online": "Max. Gruppe online",
  "c.s.default": "Standard",
  "c.s.remove": "Schicht entfernen",
  "c.s.days": "Tage",
  "c.s.plans": "Raumpläne",
  "c.s.flow": "Ankunftssteuerung",
  "c.s.limit_arrivals": "Ankünfte begrenzen",
  "c.s.per": "je",
  "c.s.min": "{n} Min.",
  "c.s.max_covers": "Max. Gedecke",
  "c.s.max_parties": "Max. Gruppen",
  "c.s.none_ph": "keine",
  "c.s.turn_times": "Verweildauer",
  "c.s.rules_one": "({n} Regel)",
  "c.s.rules_other": "({n} Regeln)",
  "c.s.party_from": "Gruppe ab",
  "c.s.to": "bis",
  "c.s.minutes": "Minuten",
  "c.s.add_turn": "+ Verweildauer",
  "c.s.take_res": "Tische, die Reservierungen annehmen",
  "c.s.take_res_hint": "(abwählen, damit ein Tisch nur für Laufkundschaft bleibt)",
  "c.s.none": "Noch keine Schichten.",
  "c.s.add": "+ Schicht hinzufügen",
  "c.s.new": "Neue Schicht",
  "c.s.remove_aria": "Entfernen",
  "c.t.label": "Bezeichnung",
  "c.t.min": "Min.",
  "c.t.max": "Max.",
  "c.t.area": "Bereich",
  "c.t.plan": "Raumplan",
  "c.t.shape": "Form",
  "c.t.shape.rect": "Rechteck",
  "c.t.shape.round": "Rund",
  "c.t.shape.diamond": "Raute",
  "c.t.remove_aria": "Tisch {label} entfernen",
  "c.t.add": "+ Tisch hinzufügen",
  "c.t.combos": "Kombinationen",
  "c.t.combos_hint": "Tische, die für größere Gruppen zusammengeschoben werden können.",
  "c.t.combos_none": "Keine.",
  "c.t.add_combo": "+ Kombination hinzufügen",
  "c.p.name": "Name",
  "c.p.requires": "Verlangt",
  "c.p.kind.none": "Nichts",
  "c.p.kind.card_hold": "Hinterlegte Karte",
  "c.p.kind.deposit": "Anzahlung",
  "c.p.amount": "Betrag",
  "c.p.per_guest": "pro Person",
  "c.p.flat": "pauschal",
  "c.p.any_ph": "beliebig",
  "c.p.cutoff": "Kostenlose Stornierung bis (Stunden vorher)",
  "c.p.charge_on": "Berechnen bei",
  "c.p.on.both": "Nichterscheinen und später Stornierung",
  "c.p.on.no_show": "nur Nichterscheinen",
  "c.p.on.late_cancel": "nur später Stornierung",
  "c.p.message": "Hinweis für den Gast (Standardsprache)",
  "c.p.message_in": "Hinweis auf {language}",
  "c.p.no_payment": "Es wird keine Zahlung verlangt.",
  "c.p.summary": "Gäste mit {from}{to} Personen zahlen {amount}{each}.",
  "c.p.each": " pro Person",
  "c.p.none": "Keine Richtlinien. Buchungen benötigen weder Karte noch Anzahlung.",
  "c.p.add": "+ Richtlinie hinzufügen",
  "c.p.new": "Neue Richtlinie",
  "c.cl.date": "Datum",
  "c.cl.title": "Titel",
  "c.cl.title_ph": "Feiertag",
  "c.cl.closed": "Geschlossen",
  "c.cl.add": "+ Datum hinzufügen",
  "c.st.interval": "Zeitraster (Minuten)",
  "c.st.turn": "Standard-Verweildauer (Minuten)",
  "c.st.large": "Große Gruppe ab",
  "c.st.off_ph": "aus",
  "c.st.release": "Neue Tage öffnen um",
  "c.st.wl_from": "Warteliste: Gruppe ab",
  "c.st.wl_to": "bis",
  "c.st.emails": "Gästen eine Bestätigung sowie Hinweise bei Änderung oder Stornierung per E-Mail senden",
  "c.st.reminder": "Erinnerung",
  "c.st.rem.0": "Aus",
  "c.st.rem.2": "2 Stunden vorher",
  "c.st.rem.4": "4 Stunden vorher",
  "c.st.rem.12": "12 Stunden vorher",
  "c.st.rem.24": "1 Tag vorher",
  "c.st.rem.48": "2 Tage vorher",
  "c.st.language": "Standardsprache",
  "c.st.offered": "Sprachen für Gäste",
  "c.st.language_hint": "Die Standardsprache sehen Gäste zuerst; sie wird auch für E-Mails verwendet, wenn kein Gast eine Sprache gewählt hat.",
  "c.st.quick_hint": "Online an/aus, Gruppengrößen, Buchungszeitraum und Tagesschluss bleiben in den Schnelleinstellungen und wirken sofort.",
  "c.h.version": "Version",
  "c.h.published": "Veröffentlicht",
  "c.h.by": "Von",
  "c.h.note": "Notiz",
  "c.h.live": "aktiv",
  "c.h.restore": "Als Entwurf wiederherstellen",
  "c.h.hint": "Beim Wiederherstellen entsteht ein Entwurf, den Sie prüfen können; erst mit dem Veröffentlichen ändert sich etwas.",
  "c.b.intro": "So erscheint Ihr Restaurant auf der Buchungsseite und in E-Mails an Gäste.",
  "c.b.accent": "Akzentfarbe",
  "c.b.logo": "Logo-Adresse (https)",
  "c.b.logo_hint": "Ein Link zu einem Bild auf Ihrer Webseite. Es wird von dort geladen, halten Sie es daher klein.",
  "c.b.phone": "Telefon",
  "c.b.address": "Adresse",
  "c.b.website": "Webseite (https)",
  "c.b.footer": "Schlusshinweis auf {language}",
  "c.b.footer_hint": "Wird am Ende jeder E-Mail angezeigt, zum Beispiel Parken oder Kleiderordnung.",
  "c.b.wording": "E-Mail-Texte",
  "c.b.wording_hint": "Lassen Sie ein Feld leer, um den Standardtext zu verwenden. Platzhalter: {guest} {restaurant} {when} {party} {code} (und {fee} bei Stornierungen).",
  "c.b.kind": "E-Mail",
  "c.b.kind.confirmation": "Bestätigung",
  "c.b.kind.reminder": "Erinnerung",
  "c.b.kind.change": "Änderungsmitteilung",
  "c.b.kind.cancellation": "Stornierung",
  "c.b.language": "Sprache",
  "c.b.subject": "Betreff",
  "c.b.lead": "Einleitungstext",
  "c.b.reset": "Standardtext verwenden",
  "c.b.preview": "Vorschau",
  "c.b.preview_failed": "Die Vorschau konnte nicht erstellt werden. Prüfen Sie die markierten Werte.",
  "c.b.preview_fee": "Mit Gebühr anzeigen",
  "c.b.preview_policy": "Kartenbedingungen anzeigen",
  "c.b.subject_label": "Betreff:",
  "l.feature.wall": "Wand",
  "l.feature.door": "Tür",
  "l.feature.window": "Fenster",
  "l.feature.pillar": "Säule",
  "l.feature.label": "Beschriftung",
  "l.combo.title": "Tischkombination für Gruppen von {min} bis {max}",
  "l.rotate_title": "Drehen (Alt = frei)",
  "l.plan_aria": "Raumplan",
  "l.add_plan_title": "Raumplan hinzufügen",
  "l.add_plan": "+ Plan",
  "l.rename": "Umbenennen",
  "l.del_plan": "Plan löschen",
  "l.del_plan_title": "Ein Plan kann entfernt werden, sobald er leer ist",
  "l.undo": "Rückgängig",
  "l.redo": "Wiederholen",
  "l.add_table": "+ Tisch",
  "l.add": "Hinzufügen:",
  "l.draw_wall": "Wand zeichnen",
  "l.draw_wall_title": "Klicken und ziehen, um eine Wand zu zeichnen (Esc zum Beenden)",
  "l.snap": "Raster",
  "l.zoom": "Zoom",
  "l.zoom_out": "Verkleinern",
  "l.zoom_in": "Vergrößern",
  "l.zoom_reset": "Zoom zurücksetzen",
  "l.canvas_aria": "Raumplan. Mit den Pfeiltasten verschieben Sie die Auswahl.",
  "l.help": "Klicken zum Auswählen, Umschalt/Strg-Klick oder einen Rahmen aufziehen, um mehrere auszuwählen; ziehen zum Verschieben, Ecke zum Skalieren, runder Griff zum Drehen; Pfeiltasten verschieben (Umschalt = größer), R dreht, Entf löscht, Strg+A wählt alles, Strg+Mausrad zoomt, Alt schaltet das Raster aus.",
  "l.overlap_one": "{n} Tisch überlappt.",
  "l.overlap_other": "{n} Tische überlappen.",
  "l.insp_empty": "Wählen Sie einen Tisch oder ein Element zum Bearbeiten. Mit Umschalt-Klick oder einem Rahmen wählen Sie mehrere aus. Wählen Sie zwei oder mehr Tische, um sie für große Gruppen zu kombinieren.",
  "l.selected": "{n} ausgewählt",
  "l.align": "Ausrichten",
  "l.align.left": "Links",
  "l.align.hcenter": "Mitte",
  "l.align.right": "Rechts",
  "l.align.top": "Oben",
  "l.align.vcenter": "Mittig",
  "l.align.bottom": "Unten",
  "l.space": "Gleichmäßig verteilen",
  "l.space_h": "Horizontal",
  "l.space_v": "Vertikal",
  "l.rotate": "Drehen",
  "l.combine": "⛓ Tische kombinieren",
  "l.combine_title": "Diese Tische gemeinsam für größere Gruppen buchbar machen",
  "l.duplicate": "Duplizieren",
  "l.delete": "Löschen",
  "l.rotation": "Drehung",
  "l.rotate_left": "Nach links drehen",
  "l.rotate_right": "Nach rechts drehen",
  "l.text": "Text",
  "l.length": "Länge",
  "l.thickness": "Stärke",
  "l.in_combos": "In Kombinationen",
  "l.table": "Tisch {label}",
  "l.table_aria": "Tisch {label}, {min} bis {max} Plätze",
  "l.label": "Bezeichnung",
  "l.min_seats": "Min. Plätze",
  "l.max_seats": "Max. Plätze",
  "l.area": "Bereich",
  "l.area_none": "Keiner",
  "l.shape": "Form",
  "l.shape.rect": "Rechteck",
  "l.shape.round": "Rund",
  "l.shape.diamond": "Raute",
  "l.width": "Breite",
  "l.height": "Höhe",
  "l.auto_size": "Automatische Größe",
  "l.auto_size_title": "Größe aus der Anzahl der Plätze",
  "l.c.title": "Tischkombination",
  "l.c.hint": "Tische, die für eine größere Gruppe zusammengeschoben werden. Bis zu {n} Plätze insgesamt.",
  "l.c.from": "Gruppe ab",
  "l.c.to": "bis",
  "l.c.tables": "Tische",
  "l.c.remove_aria": "Tisch {label} aus dieser Kombination entfernen",
  "l.c.add": "Tisch hinzufügen",
  "l.c.choose": "Auswählen…",
  "l.c.delete": "Kombination löschen",
  "l.c.exists": "Diese Tische sind bereits eine Kombination.",
  "l.plan_prompt": "Name des neuen Raumplans",
  "l.plan_default": "Etage {n}",
  "l.plan_added": "Plan hinzugefügt und allen Schichten zugeordnet. Pro Schicht können Sie das im Bereich Schichten ändern.",
  "l.plan_rename": "Raumplan umbenennen",
  "c.p.title": "Restaurantprofil",
  "c.p.hint": "Wird auf Ihrer Buchungsseite angezeigt. Gäste sehen eine kurze Vorstellung und Ihre Fotos, bevor sie eine Zeit wählen.",
  "c.p.cuisines": "Küchen (durch Komma getrennt, bis zu 5)",
  "c.p.check": "Durchschnittlicher Bon",
  "c.p.check_ph": "z. B. 25–40 € pro Person",
  "c.p.description": "Beschreibung ({language})",
  "c.p.gallery": "Fotos",
  "c.p.gallery_hint": "Bis zu 8 Fotos, PNG, JPEG, WebP oder GIF, je bis 1 MB. Sie erscheinen in dieser Reihenfolge.",
  "c.p.photo_add": "Foto hinzufügen…",
  "c.p.remove": "Entfernen",
  "c.p.left": "Nach links",
  "c.p.right": "Nach rechts",
  "c.p.big": "Das Foto ist größer als 1 MB. Bitte wählen Sie ein kleineres.",
  "x.title": "Mehr",
  "x.more": "Mehr",
  "x.more_title": "Veranstaltungen, Tisch-Benachrichtigungen, Speisekarten, Kampagnen und Schnittstellen",
  "x.tab.private": "Veranstaltungen",
  "x.tab.alerts": "Tisch-Benachrichtigungen",
  "x.tab.menus": "Speisekarten",
  "x.tab.marketing": "Kampagnen",
  "x.tab.integrations": "Schnittstellen",
  "x.saved": "Gespeichert.",
  "x.edit": "Bearbeiten",
  "x.cancel": "Abbrechen",
  "x.active": "Aktiv",
  "x.pd.requests": "Anfragen für Veranstaltungen",
  "x.pd.when": "Wann",
  "x.pd.who": "Wer",
  "x.pd.guests": "Gäste",
  "x.pd.room": "Raum",
  "x.pd.status": "Status",
  "x.pd.quote": "Angebot",
  "x.pd.deposit": "Anzahlung",
  "x.pd.none": "Noch keine Anfragen. Gäste können auf Ihrer Buchungsseite eine Veranstaltung anfragen, sobald ein Raum angelegt ist.",
  "x.pd.mail_hint": "Wenn Sie den Status auf Angeboten, Bestätigt oder Abgelehnt setzen, erhält der Gast eine E-Mail. Ein Angebot braucht einen Betrag.",
  "x.pd.s.new": "Neu",
  "x.pd.s.quoted": "Angeboten",
  "x.pd.s.confirmed": "Bestätigt",
  "x.pd.s.declined": "Abgelehnt",
  "x.pd.s.cancelled": "Storniert",
  "x.pd.rooms": "Räume",
  "x.pd.rooms_hint": "Ein Raum mit Gästebereich wird auf der Buchungsseite als Anfrage für eine Veranstaltung angeboten. Räume sind vom Raumplan getrennt.",
  "x.pd.room_name": "Name",
  "x.pd.room_new": "Neuer Raum …",
  "x.pd.min": "Min.",
  "x.pd.max": "Max.",
  "x.pd.room_del": "Diesen Raum löschen? Anfragen behalten ihre Angaben.",
  "x.al.hint": "Gäste, die einen Tag ausgebucht fanden, können sich benachrichtigen lassen, wenn ein Tisch frei wird. Gäste mit Prioritäts-Tag erfahren es zuerst, alle anderen nach 15 Minuten.",
  "x.al.none": "Keine Benachrichtigungen.",
  "x.al.priority": "Priorität",
  "x.al.s.waiting": "Wartet",
  "x.al.s.notified": "Informiert",
  "x.al.s.closed": "Geschlossen",
  "x.mn.new": "Neue Speisekarte",
  "x.mn.edit": "Speisekarte bearbeiten",
  "x.mn.title": "Titel",
  "x.mn.body": "Inhalt",
  "x.mn.format": "Eine Zeile pro Gericht: Name | Preis | Beschreibung | Kennzeichen (durch Komma getrennt, z. B. vegan). Eine Zeile mit # beginnt einen neuen Abschnitt. In jeder Sprache dieselbe Reihenfolge verwenden.",
  "x.mn.active": "Auf der Buchungsseite anzeigen",
  "x.mn.shown": "Sichtbar",
  "x.mn.hidden": "Ausgeblendet",
  "x.mn.items": "Gerichte",
  "x.mn.none": "Noch keine Speisekarten.",
  "x.mn.del": "Diese Speisekarte löschen?",
  "x.mk.new": "Neue Kampagne",
  "x.mk.hint": "Nur Gäste, die Werbe-E-Mails zugestimmt haben, erhalten diese Nachricht, und jede E-Mail enthält einen Abmeldelink. Mit {first_name} sprechen Sie jeden Gast mit Vornamen an.",
  "x.mk.subject": "Betreff",
  "x.mk.body": "Nachricht",
  "x.mk.tag": "Nur Gäste mit Tag",
  "x.mk.any": "alle",
  "x.mk.min_visits": "Mindestens so viele Besuche",
  "x.mk.not_seen": "Nicht gesehen seit (Tage)",
  "x.mk.preview": "Empfänger zählen",
  "x.mk.count": "{n} Empfänger",
  "x.mk.send": "Kampagne senden",
  "x.mk.fill": "Bitte Betreff und Nachricht eingeben.",
  "x.mk.confirm": "Diese E-Mail an {n} Gäste senden?",
  "x.mk.done": "An {n} Gäste gesendet.",
  "x.mk.sent": "Gesendete Kampagnen",
  "x.mk.recipients": "Empfänger",
  "x.mk.delivered": "Zugestellt",
  "x.mk.none": "Noch keine Kampagnen.",
  "x.in.keys": "API-Schlüssel",
  "x.in.keys_hint": "Für Ihre eigenen Systeme. Ein Lese-Schlüssel sieht Reservierungen und Berichte; ein Lese-und-Schreib-Schlüssel kann Reservierungen auch anlegen und ändern. Schlüssel erreichen nie Einstellungen, Personal, Abrechnung oder Gästedaten.",
  "x.in.name": "Name",
  "x.in.scope": "Zugriff",
  "x.in.scope.read": "Nur lesen",
  "x.in.scope.write": "Lesen und schreiben",
  "x.in.last_used": "Zuletzt genutzt",
  "x.in.revoked": "Widerrufen",
  "x.in.revoke": "Widerrufen",
  "x.in.key_new": "Name des neuen Schlüssels …",
  "x.in.revoke_confirm": "Diesen Schlüssel widerrufen? Systeme, die ihn nutzen, funktionieren dann nicht mehr.",
  "x.in.key_made": "API-Schlüssel „{name}“ erstellt. Jetzt kopieren:",
  "x.in.once": "Er wird nur einmal angezeigt und kann später nicht mehr abgerufen werden.",
  "x.in.hooks": "Webhooks",
  "x.in.hooks_hint": "Wir senden eine signierte Nachricht an Ihre Adresse, wenn eine Reservierung angelegt, geändert, gesetzt oder storniert wird. Prüfen Sie den Header x-webhook-signature mit dem Geheimnis, das beim Hinzufügen der Adresse angezeigt wird.",
  "x.in.url": "Adresse (https)",
  "x.in.events": "Ereignisse",
  "x.in.all_events": "Alle Reservierungsereignisse und Warteliste",
  "x.in.test": "Test senden",
  "x.in.hook_made": "Webhook hinzugefügt. Das Signatur-Geheimnis lautet:",
  "x.in.hook_del": "Diese Webhook-Adresse entfernen?",
  "x.in.failed": "{n} fehlgeschlagen",
  "x.in.log": "Letzte Zustellungen",
  "x.in.log_none": "Noch nichts gesendet.",
  "x.in.d.pending": "Wartet",
  "x.in.d.sent": "Zugestellt",
  "x.in.d.failed": "Fehlgeschlagen",
  "x.card.take": "Karte des Gastes jetzt aufnehmen",
  "x.card.hint": "Der Gast nennt die Karte; sie geht direkt an den Zahlungsanbieter und wird hier nie gespeichert.",
  "x.card.title": "Karte für diese Buchung",
  "x.card.go": "Karte belasten und buchen",
  "x.card.hold_note": "Es wird jetzt kein Geld abgebucht; die Karte wird für Gebühren hinterlegt.",
  "x.card.deposit_note": "{amount} werden jetzt als Anzahlung belastet.",
  "x.card.changed": "Zeit oder Personenzahl haben sich geändert. Drücken Sie die Taste erneut, um die neue Zeit zu halten.",
  "x.card.none": "Für diese Zeit ist keine Karte nötig.",
  "x.card.failed": "Die Karte wurde nicht akzeptiert.",
  "x.card.test": "Testmodus: Es sind keine Kartendaten nötig.",
  "x.card.not_ready": "Das Kartenfeld ist noch nicht bereit.",
  "x.access.title": "Zugang",
  "x.access.code": "Zugangscode (blendet das Angebot aus, bis Gäste ihn eingeben)",
  "x.access.tags": "Nur für Gäste mit Tag (durch Komma getrennt)",
  "x.tag.priority": "Priorität: erfährt zuerst von freien Tischen",
  "n.menu": "Menü",
  "n.close": "Menü schließen",
  "n.change": "Wechseln",
  "n.front": "Service",
  "n.planning": "Verfügbarkeitsplanung",
  "n.floorplan": "Raumpläne",
  "n.private": "Veranstaltungen",
  "n.reporting": "Berichte",
  "n.menus": "Speisekarten",
  "n.marketing": "Marketing",
  "n.alerts": "Tisch-Benachrichtigungen",
  "n.guests": "Gäste",
  "n.notes": "Schichtnotizen",
  "n.admin": "Verwaltung",
  "n.profile": "Restaurantprofil",
  "n.settings": "Restauranteinstellungen",
  "n.policies": "Richtlinien",
  "n.widget": "Buchungsseite",
  "n.integrations": "Schnittstellen",
  "n.accounts": "Konten",
  "n.billing": "Abrechnung",
  "n.security": "Sicherheit",
  "n.log": "Aktivitätsprotokoll",
  "n.signout": "Abmelden",
  "n.id": "Restaurant-ID {id}",
  "x.pd.reqs_none_room": "Kein Raum gewählt",
  "x.pd.save_room": "Raum speichern",
  "c.sec.schedule": "Wochenplan",
  "c.sec.experiences": "Erlebnisse",
  "c.w.show_menus": "Speisekarten auf der Buchungsseite anzeigen",
  "c.st.channels": "Kontaktkanäle",
  "c.st.sms": "Textnachrichten an Gäste senden (Tisch bereit, Verspätung)",
  "c.st.sms_hint": "Standardmäßig aus. SMS brauchen die Einwilligung des Gastes; prüfen Sie die Regeln in Ihrem Land, bevor Sie das einschalten. Außerdem muss ein SMS-Anbieter am Server angebunden sein.",
  "c.st.marketing": "Marketing-E-Mails und das Einwilligungsfeld für Marketing",
  "c.st.marketing_hint": "Standardmäßig aus. Wenn aus, fragt die Buchungsseite nicht nach Marketing-Einwilligung und Kampagnen können nicht gesendet werden. Nur einschalten, wenn Sie Newsletter senden möchten und die Einwilligungstexte für Ihr Land geprüft sind.",
  "x.cal.title": "Raumkalender",
  "x.cal.none": "Keine Veranstaltungen in diesem Monat.",
  "x.cal.no_room": "Noch kein Raum",
  "x.cal.prev": "Voriger Monat",
  "x.cal.next": "Nächster Monat",
  "r.sales.title": "Umsatz",
  "r.sales.none": "Noch keine Umsatzdaten. Verbinden Sie Ihre Kasse unter Schnittstellen; die gesendeten abgeschlossenen Bons erscheinen hier.",
  "r.sales.revenue": "Umsatz",
  "r.sales.checks_n": "{n} Bons",
  "r.sales.avg_check": "Durchschnittlicher Bon",
  "r.sales.per_cover": "Pro Gast",
  "r.sales.matched": "{n} Reservierungen zugeordnet",
  "r.sales.tips": "Trinkgeld",
  "r.sales.by_day": "Umsatz pro Tag",
  "r.sales.by_source": "Umsatz nach Buchungsquelle",
  "r.sales.unmatched": "Keiner Reservierung zugeordnet",
  "x.in.pos": "Kasse (POS)",
  "x.in.pos_hint": "Jede Kasse arbeitet anders, deshalb gibt es einen einfachen Weg: Ihre Kasse (oder ein kleines Skript daneben) sendet abgeschlossene Bons mit einem Lese-und-Schreib-API-Schlüssel an die Adresse unten. Wird derselbe Bon erneut gesendet, wird er aktualisiert. Mit reservationCode wird ein Bon einer Reservierung zugeordnet.",
  "x.in.pos_example": "Beispiel",
  "h.x.search_results": "Suchergebnisse",
  "c.b.kind.review": "Dank und Bewertungsbitte",
  "c.b.review_url": "Bewertungslink (zum Beispiel Ihre Google-Bewertungsseite)",
  "c.b.review_hint": "Gäste, die Marketing-E-Mails zugestimmt haben, erhalten zwei Stunden nach dem Besuch einen Dank mit diesem Link. Dafür muss Marketing unter Einstellungen eingeschaltet sein.",
  "c.b.accent_warn": "Diese Farbe ist zu hell für weiße Schaltflächentexte (Kontrast {ratio}:1, nötig sind mindestens 4,5:1). Gäste mit schwacher Sehkraft können es schlecht lesen.",
  "n.print": "Tagesliste und Tischkarten",
  "pr.title": "Für den Service drucken",
  "pr.hint": "Öffnet ein PDF in einem neuen Tab. Von dort drucken.",
  "pr.date": "Tag",
  "pr.shift": "Schicht",
  "pr.all_shifts": "Alle Schichten",
  "pr.list": "Tagesliste",
  "pr.list_hint": "Alle Reservierungen nach Uhrzeit, mit Tisch, Gast, Telefon und Hinweisen. Pro Zeile ein Kästchen zum Abhaken in jeder Schicht.",
  "pr.cards": "Tischkarten (gebuchte Tische)",
  "pr.cards_hint": "Eine Karte pro gebuchtem Tisch, 8 pro Seite. Ausschneiden und auf den Tisch stellen oder beschriften.",
  "pr.cards_all": "Tischkarten (alle Tische)",
  "pr.cards_all_hint": "Zusätzlich eine leere Karte für jeden freien Tisch, mit Linien für den Namen des Gastes.",
  "pr.open": "PDF öffnen",
  "c.st.daily": "Tägliche Ausdrucke",
  "c.st.daily_time": "Tagesliste und Tischkarten per E-Mail um",
  "c.st.daily_off": "Aus",
  "c.st.daily_hint": "Wird jeden Tag zu dieser Uhrzeit als zwei PDFs an die oben genannten Benachrichtigungs-Adressen gesendet. Dafür muss der E-Mail-Versand am Server eingerichtet sein.",
  "c.sec.widget": "Buchungsseite",
  "c.b.logo_upload": "Logo-Bild",
  "c.b.logo_choose": "Logo hochladen…",
  "c.b.logo_replace": "Logo ersetzen…",
  "c.b.logo_remove": "Logo entfernen",
  "c.b.logo_none": "Noch kein Logo hochgeladen.",
  "c.b.logo_uploading": "Wird hochgeladen…",
  "c.b.logo_ready": "Logo hochgeladen. Es wird mit dem Veröffentlichen aktiv.",
  "c.b.logo_rules": "PNG, JPEG, WebP oder GIF, bis 512 KB. Ein breites Bild auf transparentem oder weißem Hintergrund eignet sich am besten.",
  "c.b.logo_or_link": "Oder einen Link zu einem Bild verwenden (https)",
  "c.b.logo_big": "Dieses Bild ist größer als 512 KB. Bitte wählen Sie ein kleineres.",
  "c.w.intro": "Gestalten Sie die Buchungsseite so, wie Ihr Restaurant es braucht. Die Vorschau zeigt Ihre noch nicht veröffentlichten Änderungen.",
  "c.w.look": "Aussehen",
  "c.w.texts": "Texte",
  "c.w.fields": "Was Gäste angeben",
  "c.w.behaviour": "Verhalten",
  "c.w.css": "Eigenes CSS",
  "c.w.embed": "Auf Ihrer Webseite einbinden",
  "c.w.theme": "Design",
  "c.w.theme.light": "Hell",
  "c.w.theme.dark": "Dunkel",
  "c.w.theme.auto": "Wie das Gerät des Gastes",
  "c.w.accent": "Akzentfarbe (Buttons, Überschriften)",
  "c.w.background": "Seitenhintergrund",
  "c.w.panel": "Flächen",
  "c.w.text": "Textfarbe",
  "c.w.theme_default": "Farbe des Designs verwenden",
  "c.w.font": "Schriftart",
  "c.w.font.system": "Modern (System)",
  "c.w.font.serif": "Klassisch mit Serifen",
  "c.w.font.rounded": "Freundlich abgerundet",
  "c.w.font.mono": "Schreibmaschine",
  "c.w.radius": "Rundung der Ecken",
  "c.w.width": "Breite",
  "c.w.width.narrow": "Schmal",
  "c.w.width.normal": "Standard",
  "c.w.width.wide": "Breit",
  "c.w.button": "Buttons",
  "c.w.button.solid": "Gefüllt",
  "c.w.button.outline": "Umrandet",
  "c.w.align": "Überschrift",
  "c.w.align.left": "Links",
  "c.w.align.center": "Zentriert",
  "c.w.show_logo": "Logo anzeigen",
  "c.w.show_name": "Restaurantnamen anzeigen",
  "c.w.title": "Überschrift auf {language}",
  "c.w.title_hint": "Ersetzt den Restaurantnamen über dem Formular. Leer lassen, um den Namen zu behalten.",
  "c.w.intro_text": "Begrüßungstext auf {language}",
  "c.w.confirm_label": "Buchungs-Button auf {language}",
  "c.w.thanks": "Nachricht nach der Buchung auf {language}",
  "c.w.phone": "Telefonnummer",
  "c.w.phone.hidden": "Nicht abfragen",
  "c.w.phone.optional": "Optional",
  "c.w.phone.required": "Pflichtfeld",
  "c.w.occasion": "Nach dem Anlass fragen",
  "c.w.request": "Nach Sonderwünschen fragen",
  "c.w.marketing": "Newsletter-Kontrollkästchen anbieten",
  "c.w.sms": "SMS-Kontrollkästchen anbieten",
  "c.w.area": "Gäste zwischen Innen- und Außenbereich wählen lassen",
  "c.w.default_party": "Voreingestellte Personenzahl",
  "c.w.days_shown": "Tage mit Zeiten auf einmal",
  "c.w.time_from": "Zeitliste beginnt um",
  "c.w.time_to": "Zeitliste endet um",
  "c.w.behaviour_hint": "Gäste sehen weiterhin nur Zeiten, die wirklich frei sind.",
  "c.w.css_hint": "Für alles, was die Optionen oben nicht abdecken. Das Laden von Bildern, Schriften oder anderen Dateien ist nicht erlaubt. Nützliche Ansatzpunkte: .brand, .card, .slot, button.primary, h1, h2 sowie die Variablen --brand, --bg, --panel, --ink, --radius.",
  "c.w.css_bad": "Das eigene CSS darf keine weiteren Dateien laden (url, @import) und kein Markup enthalten.",
  "c.w.preview": "Vorschau",
  "c.w.preview_lang": "Sprache der Vorschau",
  "c.w.embed_hint": "Fügen Sie dies dort ein, wo das Buchungsformular erscheinen soll. Die Höhe passt sich selbst an.",
  "c.w.embed_link": "Direkter Link",
  "c.w.embed_copy": "Kopieren",
  "c.w.embed_copied": "Kopiert.",
  "c.w.embed_published": "Die Seite zeigt, was Sie veröffentlicht haben; nicht veröffentlichte Änderungen erscheinen nur in der Vorschau.",
  "c.d.name": "Restaurantname",
  "c.b.business": "Ihr Betrieb",
  "c.b.business_hint": "Wird auf der Buchungsseite, in jeder E-Mail und im Dashboard verwendet. Ändern Sie den Namen hier, ändert er sich nach dem Veröffentlichen überall.",
  "c.b.name": "Restaurantname",
  "c.b.legal": "Firmenname (optional)",
  "c.b.contact_email": "Kontakt-E-Mail",
  "c.w.looks": "Fertige Designs",
  "c.w.looks_hint": "Mit einem Klick werden Farben, Schriften, Texte und E-Mail-Wortlaut gesetzt. Name, Logo und Kontaktdaten bleiben erhalten, und Sie können danach alles weiter anpassen.",
  "c.w.look_apply": "Dieses Design verwenden",
  "c.w.look_confirm": "„{name}“ anwenden? Dadurch werden Farben, Schriften, Texte, Feldauswahl und E-Mail-Wortlaut in Ihrem Entwurf ersetzt. Logo und Betriebsdaten bleiben.",
  "c.w.look_applied": "„{name}“ wurde auf Ihren Entwurf angewendet. Prüfen Sie ihn und veröffentlichen Sie dann.",
  "c.w.look_share": "Ein Design in ein anderes Restaurant übernehmen",
  "c.w.look_json_hint": "Exportieren Sie das Design dieses Restaurants als Text, fügen Sie ihn im Editor eines anderen Restaurants ein und importieren Sie ihn dort.",
  "c.w.look_export": "Design exportieren",
  "c.w.look_import": "Design importieren",
  "c.w.look_bad": "Dieser Text ist kein gültiges Design.",
  "c.w.look_imported": "Design in Ihren Entwurf importiert.",
  "c.sec.areas": "Bereiche",
  "c.a.intro": "Bereiche sind die Teile Ihres Restaurants, zwischen denen Gäste wählen können, zum Beispiel ein Separee, ein Raucherbereich oder eine Terrasse. Legen Sie so viele an, wie Sie brauchen, und ordnen Sie ihnen dann im Raumplan Tische zu.",
  "c.a.quick": "Schnell hinzufügen:",
  "c.a.add": "+ Neuer Bereich",
  "c.a.none": "Noch keine Bereiche. Tische ohne Bereich sind weiterhin buchbar; Gäste bekommen nur keine Auswahl angeboten.",
  "c.a.name": "Name",
  "c.a.kind": "Art",
  "c.a.bookable": "Gäste können ihn online wählen",
  "c.a.texts": "Namen und Beschreibungen je Sprache",
  "c.a.texts_hint": "Leer lassen, um den Namen oben zu verwenden. Die Beschreibung erscheint auf der Buchungsseite unter der Platzwahl, zum Beispiel „Rauchen erlaubt, beheizt“.",
  "c.a.name_in": "Name auf {language}",
  "c.a.desc_in": "Beschreibung auf {language}",
  "c.a.tables_one": "{n} Tisch",
  "c.a.tables_other": "{n} Tische",
  "c.a.place": "Tische im Raumplan platzieren",
  "c.a.delete": "Bereich löschen",
  "c.a.delete_confirm": "Den Bereich „{name}“ löschen? Seine Tische bleiben erhalten, gehören aber keinem Bereich mehr an.",
  "l.dup_plan": "Plan kopieren",
  "l.dup_plan_title": "Diesen Raumplan mit Tischen, Wänden und Kombinationen kopieren, zum Beispiel für ein zweites Stockwerk",
  "l.dup_plan_name": "{name} (Kopie)",
  "l.move_to_plan": "In Raumplan verschieben",
  "l.bulk_area": "Bereich für alle Ausgewählten",
  "l.bulk_keep": "— unverändert —",
  "h.plans_aria": "Raumpläne",
  "l.fp.title": "Raumplan",
  "l.fp.plan_aria": "Raumplan wählen",
  "l.fp.new_plan": "+ Neuer Raumplan…",
  "l.fp.elements": "Elemente",
  "l.fp.room": "Raum",
  "l.fp.elements_hint": "Klicken Sie ein Element an, um es hinzuzufügen, oder ziehen Sie es auf den Plan.",
  "l.fp.toolbar": "Werkzeuge des Raumplans",
  "l.fp.zoom_out": "Verkleinern",
  "l.fp.zoom_fit": "Plan an das Fenster anpassen",
  "l.fp.tool_select": "Auswählen und verschieben",
  "l.fp.tool_pan": "Ansicht verschieben",
  "l.fp.rotate_left": "Nach links drehen",
  "l.fp.rotate_right": "Nach rechts drehen",
  "l.fp.tables": "Tische",
  "l.fp.locate": "Alle Tische anzeigen",
  "l.fp.start": "Wählen Sie einen Tisch aus und ziehen Sie ihn, um zu beginnen",
  "l.fp.areas": "Bereiche",
  "l.fp.new": "Neu",
  "l.fp.no_areas": "Noch keine Bereiche.",
  "l.fp.plans": "Raumpläne",
  "l.fp.tables_n_one": "{n} Tisch",
  "l.fp.tables_n_other": "{n} Tische",
  "l.fp.plans_n_one": "{n} Raumplan",
  "l.fp.plans_n_other": "{n} Raumpläne",
  "l.fp.el_one": "{shape}, {n} Platz",
  "l.fp.el_other": "{shape}, {n} Plätze",
  "l.fp.area_prompt": "Name des neuen Bereichs",
  "l.fp.area_added": "Bereich hinzugefügt. Wählen Sie Tische aus und weisen Sie ihn im rechten Bereich zu.",
  "l.fp.area_empty": "In diesem Bereich sind noch keine Tische.",
  "h.invoices": "Rechnungen",
  "h.invoices_title": "Ihre Rechnungen für das Abonnement",
  "h.inv.title": "Rechnungen",
  "h.inv.intro": "Die Rechnungen und Gutschriften für Ihr Abonnement. Jede trägt ihre rechtliche Nummer und kann als PDF heruntergeladen werden.",
  "h.inv.empty": "Es wurden noch keine Rechnungen ausgestellt.",
  "h.inv.number": "Nummer",
  "h.inv.period": "Zeitraum",
  "h.inv.date": "Datum",
  "h.inv.due": "Fällig",
  "h.inv.amount": "Betrag",
  "h.inv.status": "Status",
  "h.inv.pdf": "PDF",
  "h.inv.credit_note": "Gutschrift",
  "h.inv.status.open": "Offen",
  "h.inv.status.paid": "Bezahlt",
  "h.inv.status.credited": "Gutgeschrieben",
  "h.inv.status.issued": "Ausgestellt",
  "h.inv.method": "Hinterlegtes Zahlungsmittel: {method}",
  "h.d.erase": "Personenbezogene Daten dieses Gastes löschen",
  "h.d.erase_confirm": "Name, Kontaktdaten, Notizen und Wünsche dieses Gastes aus allen Besuchen löschen? Die Besuche bleiben in Ihrer Statistik, identifizieren aber niemanden mehr. Das kann nicht rückgängig gemacht werden.",
  "h.d.erased": "Die personenbezogenen Daten des Gastes wurden gelöscht.",
  "perm.guests.manage": "Gästebuch, Tags und Notizen ansehen und bearbeiten, Gäste exportieren",
  "perm.reports.view": "Auswertungen ansehen und Reservierungen exportieren",
  "h.x.notes": "Notizen",
  "h.x.notes_title": "Notizen und Zusammenfassung für diesen Tag",
  "h.x.guests": "Gäste",
  "h.x.guests_title": "Gästebuch, Tags und Export",
  "h.x.reports": "Auswertungen",
  "h.x.reports_title": "Auswertungen und Exporte",
  "h.x.search_ph": "Name, Telefon oder Code suchen",
  "h.x.no_results": "Keine Treffer.",
  "h.x.quotes": "Wartezeit nach Personenzahl",
  "h.x.quote_title": "{n} Personen: etwa {m} Minuten. Antippen, um auf die Warteliste zu setzen.",
  "h.x.referral": "Empfehlung",
  "h.x.referral_ph": "Wer hat uns empfohlen?",
  "h.x.visit_note": "Besuchsnotiz",
  "h.x.tags": "Tags",
  "h.x.sms_ready": "SMS: Tisch bereit",
  "h.x.sms_custom": "SMS senden…",
  "h.x.sms_no_consent": "Keine Einwilligung für SMS.",
  "h.x.sms_prompt": "Nachricht an den Gast (bis 300 Zeichen)",
  "h.x.sms_sent": "SMS gesendet. Noch {n} in diesem Monat.",
  "h.x.guestbook": "Gästebuch",
  "h.x.history": "Verlauf",
  "h.x.no_history": "Noch nichts aufgezeichnet.",
  "h.x.upcoming": "Bevorstehend",
  "h.x.visits": "Besuche",
  "h.x.cancellations": "Stornos",
  "h.x.noshows": "Nichterscheinen",
  "h.x.status_quick": "Status ändern",
  "h.x.schedule": "Belegung dieses Tisches",
  "h.x.find_guest": "Gast suchen",
  "h.x.find_guest_ph": "Name, Telefon oder E-Mail",
  "h.x.no_guest": "Kein Gast gefunden. Tragen Sie unten die Daten ein, um einen anzulegen.",
  "h.x.below_min": "Unter dem Tischminimum",
  "h.x.exceeds_max": "Über dem Tischmaximum",
  "h.x.table_free": "Dieser Tisch ist um {time} frei.",
  "h.x.table_busy": "Dieser Tisch ist um {time} bereits belegt.",
  "h.x.covers_at": "Gedecke zu dieser Zeit: {covers}",
  "h.x.add_note": "Notiz hinzufügen",
  "h.x.note_title": "Titel",
  "h.x.note_scope": "Gilt für",
  "h.x.note_body": "Details",
  "h.x.note_event": "Dies ist eine besondere Veranstaltung",
  "h.x.all_day": "Ganztägig",
  "h.x.no_notes": "Keine Notizen für diesen Tag.",
  "h.x.kind.event": "Veranstaltung",
  "h.x.kind.general": "Notiz",
  "h.x.delete": "Löschen",
  "h.x.shift_summary": "Was die Schicht wissen sollte",
  "h.x.sum_large": "Große Gruppen",
  "h.x.sum_requests": "Gästewünsche",
  "h.x.sum_visit": "Besuchsnotizen",
  "h.x.sum_events": "Besondere Anlässe",
  "h.x.ev.reservation.create": "Gebucht",
  "h.x.ev.reservation.modify": "Geändert",
  "h.x.ev.reservation.cancel": "Storniert",
  "h.x.ev.reservation.no_show": "Als Nichterscheinen markiert",
  "h.x.ev.reservation.seat": "Platziert",
  "h.x.ev.reservation.move": "Umgesetzt",
  "h.x.ev.reservation.preassign": "Tisch zugewiesen",
  "h.x.ev.reservation.status": "Status geändert",
  "h.x.ev.reservation.update": "Angaben aktualisiert",
  "h.x.ev.sms.sent": "SMS gesendet",
  "h.x.ev.guest.erased": "Gastdaten gelöscht",
  "h.x.ev.walkin.seat": "Laufkundschaft platziert",
  "g.title": "Gästebuch",
  "g.tab.guests": "Gäste",
  "g.tab.tags": "Tags",
  "g.search": "Name, E-Mail, Telefon oder Firma suchen",
  "g.tag": "Tag",
  "g.all_tags": "Alle",
  "g.sort": "Sortieren nach",
  "g.sort.name": "Name",
  "g.sort.visits": "Meiste Besuche",
  "g.sort.last_visit": "Letzter Besuch",
  "g.sort.created": "Neueste",
  "g.count": "{n} Gäste",
  "g.new": "Neuer Gast",
  "g.export": "CSV exportieren",
  "g.none": "Noch keine Gäste.",
  "g.col.name": "Name",
  "g.col.contact": "Kontakt",
  "g.col.visits": "Besuche",
  "g.col.upcoming": "Bevorstehend",
  "g.col.cancellations": "Stornos",
  "g.col.noshows": "Nichterscheinen",
  "g.col.last": "Letzter Besuch",
  "g.col.tags": "Tags",
  "g.first": "Vorname",
  "g.last": "Nachname",
  "g.phone": "Telefon",
  "g.email": "E-Mail",
  "g.company": "Firma",
  "g.marketing": "Hat E-Mail-Marketing zugestimmt",
  "g.sms": "Hat SMS-Hinweisen zugestimmt",
  "g.note.general": "Allgemeine Notizen",
  "g.note.relationship": "Besondere Beziehung",
  "g.note.food_drink": "Essen und Trinken",
  "g.note.seating": "Sitzplatzwünsche",
  "g.hide": "Gast ausblenden",
  "g.unhide": "Gast wieder anzeigen",
  "g.history": "Besuche",
  "g.no_history": "Noch keine Besuche.",
  "g.saved": "Gast gespeichert.",
  "g.tags_hint": "Manuelle Tags setzen Sie am Gast. Geben Sie einem Tag eine Besuchszahl, um ihn automatisch allen zu geben, die mindestens so oft da waren.",
  "g.tag_name": "Name",
  "g.tag_color": "Farbe",
  "g.tag_auto": "Automatisch nach Besuchen",
  "g.tag_new": "Neuer Tag",
  "g.manual": "Manuell",
  "g.add": "Hinzufügen",
  "g.delete": "Löschen",
  "g.delete_confirm": "Diesen Tag löschen? Er wird bei jedem Gast entfernt.",
  "r.title": "Auswertungen",
  "r.from": "Von",
  "r.to": "Bis",
  "r.last": "Letzte {n} Tage",
  "r.export": "Reservierungen exportieren (CSV)",
  "r.none": "Keine Daten.",
  "r.no_data": "Keine Daten in diesem Zeitraum.",
  "r.covers": "Gedecke",
  "r.vs_prev": "{d} gegenüber dem Zeitraum davor",
  "r.parties": "Gruppen",
  "r.walkins": "Gedecke Laufkundschaft",
  "r.noshows": "Nichterscheinen",
  "r.rate": "{p} % der Buchungen",
  "r.cancellations": "Stornos",
  "r.first_time": "Erstbesucher",
  "r.repeat": "{n} wiederkehrend",
  "r.lead": "Durchschnittliche Vorlaufzeit",
  "r.days": "{n} Tage",
  "r.by_day": "Gedecke pro Tag",
  "r.by_source": "Gedecke nach Quelle",
  "r.by_size": "Gruppen nach Größe",
  "r.by_weekday": "Durchschnittliche Gedecke nach Wochentag",
  "r.by_shift": "Gedecke nach Schicht (reserviert + Laufkundschaft)",
  "r.reserved": "Reserviert",
  "r.walkin": "Laufkundschaft",
  "r.avg": "Ø",
  "r.turn": "Tischzeiten",
  "r.party": "Gruppe",
  "r.actual": "Tatsächlich",
  "r.planned": "Geplant",
  "r.diff": "Differenz",
  "r.min": "Min.",
  "r.turn_hint": "Tatsächlich ist die Zeit vom Platzieren bis zum Abschluss. Liegt sie oft über der geplanten, erhöhen Sie die Tischzeit unter Konfiguration → Schichten.",
  "r.footnote_one": "Gedecke zählen Gäste in Reservierungen, die weder storniert noch nicht wahrgenommen wurden. Eine Gruppe in diesem Zeitraum.",
  "r.footnote_other": "Gedecke zählen Gäste in Reservierungen, die weder storniert noch nicht wahrgenommen wurden. {n} Gruppen in diesem Zeitraum.",
  "c.st.horizon": "Gäste können buchen bis (Tage im Voraus)",
  "c.st.horizon_hint": "Neue Tage öffnen zur unten genannten Freigabezeit. Der letzte buchbare Tag ist heute der {date}.",
  "c.st.notify": "Diese E-Mail-Adressen benachrichtigen",
  "c.st.notify_hint": "Mehrere Adressen mit Komma trennen. Sie erhalten eine kurze E-Mail, wenn eines der Ereignisse unten eintritt.",
  "c.st.notify_ev.new_online": "Neue Online-Reservierung",
  "c.st.notify_ev.cancellation": "Stornierung durch den Gast",
  "c.st.notify_ev.large_party": "Große Gruppe",
  "c.w.terms": "Allgemeine Geschäftsbedingungen",
  "c.w.terms_required": "Gäste müssen die Bedingungen vor der Buchung akzeptieren",
  "c.w.terms_text": "Text neben dem Kontrollkästchen auf {language}",
  "c.w.terms_hint": "Zum Beispiel „Ich akzeptiere die Hausregeln und die Stornobedingungen.“ Ohne Text in einer Sprache erscheint ein Standardsatz.",
  "c.cl.copy": "Kopieren",
  "c.cl.copy_title": "Diesen Tag mit seinen eigenen Schichten auf ein anderes Datum kopieren",
  "c.cl.copy_prompt": "Auf welches Datum kopieren? (JJJJ-MM-TT)",
  "c.cl.copy_exists": "Für dieses Datum gibt es schon einen besonderen Tag.",
  "c.cl.range": "Zeitraum schließen…",
  "c.cl.holidays": "Feiertage hinzufügen…",
  "c.cl.country": "Land",
  "c.cl.year": "Jahr",
  "c.cl.from": "Von",
  "c.cl.to": "Bis",
  "c.cl.range_ph": "Zum Beispiel Sommerpause",
  "c.cl.range_apply": "Diese Tage schließen",
  "c.cl.range_bad": "Wählen Sie Anfang und Ende, wobei das Ende nicht vor dem Anfang liegen darf.",
  "c.cl.have": "bereits vorhanden",
  "c.cl.hol_apply": "Ausgewählte Feiertage als Ruhetage hinzufügen",
  "c.cl.hol_added": "{n} Feiertage hinzugefügt.",
  "c.cl.tools_hint": "Feiertage sind Vorschläge und enthalten keine regionalen. Änderungen gehen mit dem Veröffentlichen live.",
  "c.sg.intro": "Ihre reguläre Woche auf einen Blick. Ziehen Sie einen Block nach oben oder unten, um eine Schicht zu verschieben, oder seinen unteren Rand, um die letzte Platzierung zu ändern. Klicken Sie einen Block an, um ihn zu bearbeiten.",
  "c.sg.hint": "Klicken Sie eine Schicht an, um sie zu bearbeiten, oder fügen Sie eine neue hinzu.",
  "c.sg.hint_edit": "Änderungen gelten für jeden Tag, an dem diese Schicht läuft.",
  "c.sg.add": "+ Schicht hinzufügen",
  "c.sg.new": "Neue Schicht",
  "c.w.embed_auto": "Sprache des Gastes",
  "c.w.embed_height": "Höhe (px)",
  "c.w.qr_booking": "QR-Code der Buchungsseite",
  "c.w.qr_waitlist": "QR-Code der Warteliste (Gäste tragen sich per Handy ein)",
  "c.w.qr_download": "SVG herunterladen",
  "c.x.intro": "Erlebnisse sind besondere Angebote wie ein Degustationsmenü oder ein Brunch. Gäste wählen eines auf der Buchungsseite, und es werden nur Zeiten und Gruppengrößen innerhalb seines Rahmens angeboten. Änderungen hier gelten sofort; sie müssen nicht veröffentlicht werden.",
  "c.x.add": "+ Neues Erlebnis",
  "c.x.none": "Noch keine Erlebnisse.",
  "c.x.new": "Neues Erlebnis",
  "c.x.saved": "Erlebnis gespeichert.",
  "c.x.delete_confirm": "Dieses Erlebnis löschen? Bestehende Buchungen bleiben erhalten, verlieren aber die Verknüpfung.",
  "c.x.title": "Titel auf {language}",
  "c.x.desc": "Beschreibung auf {language}",
  "c.x.price": "Preis pro Person",
  "c.x.start": "Von",
  "c.x.end": "Bis",
  "c.x.min_party": "Kleinste Gruppe",
  "c.x.max_party": "Größte Gruppe",
  "c.x.max_covers": "Gäste pro Tag, höchstens",
  "c.x.unlimited": "Keine Grenze",
  "c.x.from": "Angeboten ab",
  "c.x.to": "Angeboten bis",
  "c.x.active": "Gästen anzeigen",
  "h.y.feed": "Aktivität",
  "h.y.feed_title": "Neue und geänderte Reservierungen",
  "h.y.feed_hint": "Was Gäste und Mitarbeiter gebucht, geändert oder storniert haben. Eine verschobene Buchung zeigt ihre alte Zeit durchgestrichen.",
  "h.y.feed_none": "Noch nichts.",
  "h.y.mark_seen": "Alles als gesehen markieren",
  "h.y.f.create": "gebucht",
  "h.y.f.modify": "geändert",
  "h.y.f.cancel": "storniert",
  "h.y.f.noshow": "nicht erschienen",
  "h.y.f.online": "Online-Gast",
  "h.y.problems": "Probleme",
  "h.y.problems_title": "Reservierungen, die Aufmerksamkeit brauchen",
  "h.y.problems_none": "Im Moment braucht nichts Aufmerksamkeit.",
  "h.y.p.unassigned": "Kein Tisch zugewiesen, beginnt bald",
  "h.y.p.late": "Verspätet: {n} Min. nach der Zeit",
  "h.y.p.overdue": "Geplante Zeit um {n} Min. überschritten",
  "h.y.p.too_big": "Der zugewiesene Tisch ist zu klein",
  "h.y.audit": "Protokoll",
  "h.y.audit_title": "Wer hat was getan",
  "h.y.audit_hint": "Die letzten Aktionen von Mitarbeitern und Gästen in diesem Restaurant.",
  "h.y.when": "Wann",
  "h.y.who": "Wer",
  "h.y.what": "Was",
  "h.y.ref": "Referenz",
  "h.y.switch": "Restaurant wechseln",
  "h.y.asof_title": "Den Raum zu einer anderen Zeit ansehen",
  "h.y.asof_hint": "Zeigt anhand der Buchungen, welche Tische zu dieser Zeit belegt sind. Es wird nichts geändert.",
  "h.y.asof_now": "Jetzt",
  "h.y.asof_show": "Anzeigen",
  "h.y.update_status": "Status ändern",
  "h.y.change": "Buchung ändern",
  "h.y.change_time": "Zeit ändern",
  "h.y.change_party": "Personenzahl ändern",
  "h.y.change_duration": "Dauer ändern",
  "h.y.experience": "Erlebnis",
  "h.y.no_experience": "Keines",
  "h.y.send_confirmation": "Die Standard-Buchungsbestätigung senden",
  "h.y.to_waitlist": "Stattdessen auf die Warteliste",
  "h.y.find_times": "Freie Zeiten anzeigen",
  "h.y.confirm_table": "Tisch bestätigen",
  "h.y.confirm": "Bestätigen",
  "h.y.avail_free": "Tisch {label} ist frei.",
  "h.y.avail_until": "Tisch {label} ist jetzt frei, bis {time}.",
  "h.y.avail_next": "Tisch {label} ist frei; die nächste Buchung ist um {time}.",
  "h.y.avail_busy": "Tisch {label} ist gerade belegt.",
  "h.y.avail_blocked": "Tisch {label} ist gesperrt.",
  "h.y.next_to_seat": "Als Nächstes platzieren:",
  "h.y.min_ago": "vor {n} Min.",
  "h.y.cal_legend": "Gedecke: regulär · Laufkundschaft · ★ Erlebnisse",
};
